<div fxFlex fxLayout="column">
  <div style="background-color:white;" fxLayout="column" fxLayoutAlign="start start" *ngIf="report.tasks != null">
    <div fxLayout="column">
      <ng-container *ngFor="let tasks of report.tasks | groupBy: 'Color' | pairs">
        <ng-container *ngIf="tasks[0] == 'Green'">
          <h2 style="font-weight:500;">Inspection</h2>
          <div fxFlex style="border-radius:8px;border:1px solid #dadce0;padding:16px;" fxLayout="row wrap"
            fxLayoutAlign="start start">
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex.xs="100" fxFlex.gt-xs="50"
              *ngFor="let task of tasks[1]; let i = index" style="padding:4px;">
              <mat-icon *ngIf="task.Color == 'Green'" style="color:#4CAF50;margin-right:4px;">check_circle
              </mat-icon>
              <span>{{task.TaskName}} {{getFluidFilled(task.FluidFilled)}}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <h2 style="font-weight:500;">Tires</h2>
      <div fxLayout="column" *ngIf="report?.tires?.length > 0" fxFlex
        style="border-radius:8px;border:1px solid #dadce0;padding:16px;">
        <div fxLayout="row wrap" fxLayoutAlign="space-around center" style="padding:4px;">
          <div fxFlex="50">
            LF
            <div fxLayout="column">
              <span> {{report.tires[0].wearPattern}}</span>
              <span>In: {{report.tires[0].psiIn}} // Out: {{report.tires[0].psiOut}}</span>
              <span> {{report.tires[0].treadDepth}}/32</span>
            </div>
          </div>
          <div fxFlex="50">
            RF
            <div fxLayout="column">
              <span> {{report.tires[2].wearPattern}}</span>
              <span>In: {{report.tires[2].psiIn}} // Out: {{report.tires[2].psiOut}}</span>
              <span> {{report.tires[2].treadDepth}}/32</span>
            </div>
          </div>
          <div fxFlex="50" *ngIf="!hasDualRearTireSection(report?.tires)">
            LR
            <div fxLayout="column">
              <span> {{report.tires[1].wearPattern}}</span>
              <span>In: {{report.tires[1].psiIn}} // Out: {{report.tires[1].psiOut}}</span>
              <span> {{report.tires[1].treadDepth}}/32</span>
            </div>
          </div>
          <div fxFlex="50" *ngIf="!hasDualRearTireSection(report?.tires)">
            RR
            <div fxLayout="column">
              <span> {{report.tires[3].wearPattern}}</span>
              <span>In: {{report.tires[3].psiIn}} // Out: {{report.tires[3].psiOut}}</span>
              <span> {{report.tires[3].treadDepth}}/32</span>
            </div>
          </div>

          <div fxLayout="column wrap" style="margin-top:24px" fxFlex="50" fxLayoutAlign="center start">
            <div fxLayout="row" fxFlex style="margin-bottom:4px;height:24px;padding:4px" fxLayoutAlign="start center"
              *ngFor="let task of report.tireOther">
              <mat-icon *ngIf="task.Color === 'Red'">cancel</mat-icon>
              <span *ngIf="task.Color === 'Red'">{{task.TaskName}}</span>
            </div>
          </div>
          <!--
          <div fxFlex="50" fxLayout="column" fxLayoutAlign="center start">
            <h3 style="margin-left:24px; margin-bottom:4px;margin-top:8px;text-decoration:underline;">Tread</h3>
            <div fxLayout="row" style="padding-left:4px" fxLayoutAlign="start center">
              <mat-icon *ngIf="report.tires[0].green">check_circle
              </mat-icon>
              <mat-icon *ngIf="report.tires[0].yellow">warning
              </mat-icon>
              <mat-icon *ngIf="report.tires[0].red">cancel</mat-icon>
              <b style="margin-right:2px">LF:</b>
              <span> {{report.tires[0].treadDepth}}/32</span>
            </div>
            <div fxLayout="row" style="padding-left:4px" fxLayoutAlign="start center">
              <mat-icon *ngIf="report.tires[2].green">check_circle
              </mat-icon>
              <mat-icon *ngIf="report.tires[2].yellow">warning
              </mat-icon>
              <mat-icon *ngIf="report.tires[2].red">cancel</mat-icon>
              <b style="margin-right:2px">RF:</b>
              <span> {{report.tires[2].treadDepth}}/32</span>
            </div>
            <div fxLayout="row" style="padding-left:4px" fxLayoutAlign="start center">
              <mat-icon *ngIf="report.tires[1].green">check_circle
              </mat-icon>
              <mat-icon *ngIf="report.tires[1].yellow">warning
              </mat-icon>
              <mat-icon *ngIf="report.tires[1].red">cancel</mat-icon>
              <b style="margin-right:2px">LR:</b>
              <span> {{report.tires[1].treadDepth}}/32</span>
            </div>
            <div fxLayout="row" style="padding-left:4px" fxLayoutAlign="start center">
              <mat-icon *ngIf="report.tires[3].green">check_circle
              </mat-icon>
              <mat-icon *ngIf="report.tires[3].yellow">warning
              </mat-icon>
              <mat-icon *ngIf="report.tires[3].red">cancel</mat-icon>
              <b style="margin-right:2px">RR:</b>
              <span> {{report.tires[3].treadDepth}}/32</span>
            </div>
          </div> -->
        </div>
        <div *ngIf="report?.taskOther?.length > 0">
          <div fxLayout="row" fxLayoutAlign="center center">
            <h3>Battery Voltage & Oil Life</h3>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="space-around center">
            <div style="padding:4px;" fxLayout="row" fxFlex="50" fxLayoutAlign="start center">
              <mat-icon>battery_full</mat-icon>
              <span>{{report.taskOther[0].TaskName}}: {{report.taskOther[0].BatteryVoltage}}v</span>
            </div>
            <div style="padding:4px;" fxLayout="row" fxFlex="50" fxLayoutAlign="start center">
              <mat-icon>opacity</mat-icon>
              <span>{{report.taskOther[1].TaskName}}: {{report.taskOther[1].OilLife}}%</span>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngFor="let dualSection of getOptionalTireSections(report?.tires)">
        <h2 style="font-weight:500;">{{dualSection.categoryName}}</h2>
        <div fxLayout="column" fxFlex style="border-radius:8px;border:1px solid #dadce0;padding:16px;">
          <div fxLayout="row wrap" fxLayoutAlign="space-around center" style="padding:4px;">
            <div fxFlex="50" *ngFor="let tire of dualSection.tires">
              {{tire.taskName}}
              <div fxLayout="column">
                <span> {{tire.wearPattern}}</span>
                <span>In: {{tire.psiIn}} // Out: {{tire.psiOut}}</span>
                <span> {{tire.treadDepth}}/32</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div fxLayout="column">
      <ng-template *ngFor="let tasks of report.tasks | groupBy: 'Color' | pairs;let i = index">
        <div fxFlex="50" style="border:2px solid black;margin:8px;" *ngIf="tasks[0] =='Red' || tasks[0]=='Yellow'"
          fxLayout="row wrap" fxLayoutAlign="start start">
          <div fxLayout="row" fxLayoutAlign="center center">
            <h3>{{getStatus(tasks[0])}}</h3>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="50 " *ngFor="let task of tasks[1]; let i = index"
            style="padding:4px;">
            <mat-icon *ngIf="task.Color=='Yellow'">warning</mat-icon>
            <mat-icon *ngIf="task.Color=='Red'">cancel</mat-icon>
            <span>{{task.TaskName}} {{getFluidFilled(task.FluidFilled)}}</span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div style="page-break-before:always;margin:8px;position:relative;display:block; "
    *ngIf="report?.quoteLines?.length >  0" fxLayout="column">
    <h2 style="font-weight:500;">Quotes</h2>
    <!-- <div id="quoteContainer">
      <div [id]="i.toString()" style="page-break-inside:avoid;margin-bottom:12px;position:relative;display:block;"
        *ngFor="let line
                        of report.quoteLines | orderBy: [ 'Case'];let i = index">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="column" fxLayoutAlign="center start">
            <span style="text-decoration: underline; word-break: break-word">Case {{line.Case}} -
              {{line.TaskName}}</span>
            <span style="margin:2px 0px 2px 8px;">{{line.RecommendedHours | number:'1'}} Labour Hours
              -
              <i>Expires {{line.ExpirationDate }}</i>
            </span>
            <span style="margin:2px 0px 2px 8px;">Employee: {{line.Employee}}</span>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" style="margin-left:8px;">
          <div fxFlex="65" fxLayoutAlign="start start" fxLayout="column">
            <div fxLayout="column">
              <span class="mat-body-2">
                Concern
              </span>
              <span style="margin:2px 0px 2px 8px; word-break: break-word">{{line.Note || "Not Available " }}</span>
            </div>
            <div fxLayout="column">
              <span class="mat-body-2">
                Cause
              </span>
              <span style="margin:2px 0px 2px 8px; word-break: break-word">{{line.Cause || "Not Available "}} </span>
            </div>
            <div fxLayout="column">
              <span class="mat-body-2">
                Correction
              </span>
              <span
                style="margin:2px 0px 2px 8px; word-break: break-word;">{{line.Recommendation || "Not Available "}}</span>
            </div>
          </div>
          <div fxFlex="30" fxLayout="row wrap" fxLayoutAlign="start start" style="margin-right:8px;">
            <div fxLayout="row" fxFlex="100">
              <span class="mat-body-2">Subtotals</span>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                        8px; ">
              <span>Labour:</span>
              <span>{{line.labourSubTotal | currency:'$'}}</span>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                        8px;">
              <span>Parts:</span>
              <span>{{line.partsSubTotal | currency:'$'}}</span>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                        8px;">
              <span>Additional Charges:</span>
              <span>{{line.additionalCharges | currency:'$'}} </span>
            </div>
            <div fxLayout="row" fxFlex="100 " fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                        8px;">
              <span>Tax:</span>
              <span>{{line.tax | currency: '$'}}</span>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center">
              <span class="mat-body-2">Total:</span>
              <span class="mat-body-2">{{line.CaseTotal| currency:'$'}}</span>
            </div>
          </div>
        </div>
        <mat-divider style="margin-top:8px;"></mat-divider>
      </div>
    </div> -->
    <div fxLayout="column" style="width:100%;">
      <div fxLayout="row" fxLayoutAlign="start start"
        *ngFor="let line of report.quoteLines | orderBy: [ 'Case'];let i = index;" style="padding-bottom:20px;">
        <div class="test-container" fxLayoutAlign="center center">
          <span class="test-content">{{line.Case}}</span>
        </div>
        <div fxLayout="column" fxFlex>
          <div fxLayoutAlign="start start">
            <a class="mat-body-2">
              {{line.TaskName}}
            </a>
          </div>
          <div fxLayout="column">
            <div fxLayout="column" style="color:rgb(82,82,82);">
              <div fxLayoutAlign="start center">
                <!-- <span style="font-weight:500">{{case.warrantySubmissionTypeId}}</span> -->
                <span style="margin:0 4px;font-size:24px;">·</span>
                <span>{{line.Employee}}</span>
              </div>
              <div fxLayoutAlign="start center">
                <span class="primary-bullet">·</span>
                <span class="mat-caption">Cause: {{line.Cause}}</span>
              </div>
              <div fxLayoutAlign="start center">
                <span class="primary-bullet">·</span>
                <span class="mat-caption">Correction: {{line.Recommendation}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div id="quoteTotal" fxLayout="column" fxLayoutAlign="center end" style="width:100%;">
      <span style="font-weight:500;">Quote Total: {{getQuoteTotal(report.quoteLines) | currency:'$'}}
      </span>
      <span>*Shop supplies may apply.</span>
    </div>
  </div>
</div>